module.exports = __webpack_public_path__ + "static/media/5.2315bbf9.jpg";